import ResultadoObtengaParametros from "../Contenedores/Padron/ResultadoObtengaParametros";
import { Notificar } from "../componentes/Comunes/Notificador";
import SolicitudDePadron from "../servicios/SolicitudDePadron";

export function __CargarResultadoParametrosSolicitud(datos) {
  let resultado = new ResultadoObtengaParametros();

  resultado.ListaClaseDatos = datos.clasesDeDatos;
  resultado.ListaFechasEnvio = datos.fechasEnvio;
  resultado.ListaEstado = datos.tiposEstado;
  resultado.ListaTiposSolicitud = datos.tiposSolicitud;

  return resultado;
}

export async function __ValidaEsRechazo(Validacion) {
  if (Validacion?.tipoRechazo?.id !== null) return true;
  return false;
}

export async function __CargaTiposDocumentosSolicitudesDePadron() {
  let tiposDocumentos =
    await SolicitudDePadron.ObtengaTiposDocumentosSolicitudPadron();

  if (!tiposDocumentos) {
    Notificar("error", "No se pudieron obtener los tipos de documentos.");
    return;
  }

  return tiposDocumentos;
}
